import React from "react";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "../../context/ThemeContext";
import { getAppTheme } from "../../config/resolve-app-brand";

const HelpTooltip = ({ tooltipContent }) => {
  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <Tooltip
      title={tooltipContent}
      arrow
      placement="right"
      slotProps={{
        arrow: {
          sx: {
            color: theme.typography.linkColor,
          },
        },
        tooltip: {
          sx: {
            bgcolor: theme.typography.linkColor,
            maxWidth: isMobile ? "200px" : "357px",
            minWidth: isMobile ? "200px" : "350px",
          },
        },
      }}
    >
      <HelpOutlineIcon
        sx={{
          fontSize: "20px",
          cursor: "pointer",
          color: theme.typography.linkColor,
        }}
      />
    </Tooltip>
  );
};

export default HelpTooltip;
